const ACC_TYPE_PIPEDRIVE = 'pipedrive';
const ACC_TYPE_WEBCRM = 'webcrm';

export { ACC_TYPE_PIPEDRIVE, ACC_TYPE_WEBCRM };